import loadAuth from './load-auth';
import loadConfig from './load-config';
import loadTranslations from './load-translations';
import initSentry from './load-sentry';
import loadAmplitude from './load-amplitude';
import loadAgencySettings from './load-agency-settings';
import loadKiosk from './load-kiosk';

const startup = async (): Promise<void> => {
  await loadConfig();
  await initSentry();
  await loadAmplitude();
  await loadTranslations();
  await loadAgencySettings();
  await loadAuth();
  await loadKiosk();
};

export default startup;
